import { useCallback } from 'react';
import type { GoodsDiscountGroupItem } from 'shared/src/api';
import { bridge } from 'shared/src/utils';

export const useLogClickCheckBox = (item: GoodsDiscountGroupItem) => {
  return useCallback(
    (isOn: boolean) => {
      bridge.logAnalyticsEvent({
        name: 'CLICK_CHECKBOX',
        analytics: {
          IS_ON: isOn ? '1' : '0',
          ...item.logging.analytics,
          SCREEN: 'GOODS_DETAIL',
        },
      });
    },
    [item.logging.analytics],
  );
};
